import { request } from '@/common/services/request';
import type { PlatformCoinConfig } from '@/types/api';

export type { PlatformCoinConfig };

/** GET /v1/config/platform-coin */
export const getPlatformCoin = (): Promise<PlatformCoinConfig> => {
  return request({
    url: '/v1/config/platform-coin',
    method: 'GET',
    skipAuth: true,
  });
};
